export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    // 
    /*
    // eslint-disable-next-line no-undef
    let obj = content;

    let colBreak = 991;
    //let asset = content.assetPath;

    let desktopMask = obj.assetPath + 'images/home-page/assure-homepage-mask.svg';
    let mobileMask  = obj.assetPath + 'images/backgrounds/home-bg-mobile.svg';
    //let $homeHeader = $('.block-heading__home');

    //function changeHomeMask() {
    //  console.log('change home mask');
    //  console.log(ajaxObj);
    //  console.log(desktopMask);
    //  console.log(desktopMask);
    //}


    function changeHomeMaskImage($path) {
      let path = 'url(' + $path + ')';

     $('.block-heading__home').css('mask-image', path);
     $('.block-heading__home').css('mask-image', path);
      console.log(desktopMask);
      console.log(mobileMask);
    }

    maskCheck();
    function maskCheck() {
      return;
       let $w = $(document).width();

       if($w <= colBreak) {
          changeHomeMaskImage(mobileMask);
          console.log('do mobile mask');
       }

       if($w > colBreak) {
          changeHomeMaskImage(desktopMask);
          console.log('do mobile mask');   
       }    	
    }



    $(window).resize(function(){
      maskCheck();
    });*/

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js